<template>
      <button v-on:click="createProject()" class="btn btnsabtvam text-nowrap mx-1">
              ایجاد پروژه
      </button>
</template>
<script>
export default {
  
  computed: {
    IsLogin: {
      get: function () {
        return this.$cookie.get("ApiToken") != null;
      },
    },
  },
  data() {
    return {
      
    };
  },
  methods: {
    
    createProject(){
      // /project/create
          this.$http.get("case/create").then(
          (response) => {
          console.log('create-response',response.body);
          if (response.status == 403) {
              this.ErrorMessage(response.body,'نیاز به مجوز');
            }
            if (response.status == 412) {
              this.ErrorMessage(response.body,'نیاز تکمیل پروفایل','confirm');
            }
            if (response.status == 200) {
                        this.GoTo(0);
            }
          },
          (data) => {
            console.log('create-data',data);
          if (data.status == 403) {
              this.ErrorMessage(data.body,"صبر کنید!");
             // this.GoTo(data.body);
            }
            if (data.status == 412) {
              this.ErrorMessage(data.body,"نیاز به تکمیل پروفایل",'confirm');
            }
          
            
          }
    );
    },
    ErrorMessage(text,title,type='alarm') {
      console.log('error-message',text, title);
      //if (type=='confirm')
       this.$fire({
            title: title,
            html:text.message ,
            type: "error",
            timer: 60000,
            showCancelButton: type =='confirm'? true : false,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            cancelButtonText: 'انصراف',
            confirmButtonText: type =='confirm'? 'ویرایش پروفایل' : 'متوجه شدم!',
          }).then(r => {
            if (r.value){
               console.log('confirm',r,r.value, text.link);
               this.$router.push({ path: text.link });
            }
           
          }); 
       //this.$alert(text +'fdfdfdfdfdf',null,"error");
    },
    GoTo(id){
      if(id == 0){
      this.$router.push({
        name: "create-project",
      });
      }
      else{
      this.$router.push({
        name: "create-project",
        params: { id: id },
      });
      }
    },
    
   
    IsUserAuthenticated() {
      return this.$cookie.get("ApiToken") == null;
    },
     
  },
   
}
</script>
<style lang="scss">
$themeColorGreen: #3bcf93;
  .btnsabtvam
   {
    font-family: IRANSansWeb;
    font-style: normal;
    font-weight: bold;
    font-size: 13px;
    line-height: 33px;
    letter-spacing: 0.02em;
    color: #ffffff;
    border: 2px solid #ffffff;
    box-sizing: border-box;
    border-radius: 5px;
    margin: 0px 14px 0px 0px;
    width: 5rem;
    height: 3.25rem;
    &:hover {
      color: #fff;
    }
    &:focus {
      box-shadow: none;
    }
  }
  
 
  
  .btnsabtvam
   {
    font-family: IRANSansWeb;
    font-style: normal;
    font-weight: bold;
    font-size: 13px;
    line-height: 33px;
    letter-spacing: 0.02em;
    color: #ffffff;
    background-color: #388a69;
    box-sizing: border-box;
    border-radius: 5px;
    margin: 0px 14px 0px 0px;
    width: 5rem;
    height: 3.25rem;
    &:hover {
      color: #fff;
    }
    &:focus {
      box-shadow: none;
    }
  }
  

</style>